import { render, staticRenderFns } from "./AnimateFade.vue?vue&type=template&id=1b3bfc8f&"
import script from "./AnimateFade.vue?vue&type=script&lang=ts&"
export * from "./AnimateFade.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports